export const FADE_CONFIG = {
  config: {
    mass: 20,
  },
}
